import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
export const task: Task = {
  id: "f883cbcc-9513-4ecb-bbf4-593f83fbdd9b",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Recommended minimum width of the cavity between two leaves in a lightweight party wall detail:",
    suffixText: "mm",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 50,
};
